import { Component, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import type { LiveReaderCheckOutcome, LiveReaderRefusal } from '../live-reader-refusal';


@Component({
  selector: 'app-live-reader-refusal-modal',
  templateUrl: './live-reader-refusal-modal.component.html',
})
export class LiveReaderRefusalModalComponent implements OnDestroy {
  @Input() refusal: LiveReaderRefusal;
  @Input() onProceed: () => void;
  // Called when the modal closes without proceeding, unless a check already moved the host on.
  @Input() onDismiss: () => void = null;

  // Double-submit guard, as in SimpleMessageModalComponent (PRO-1285).
  public confirming = false;

  private settled = false;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  public handleProceed() {
    if (this.confirming) { return; }
    this.confirming = true;
    this.settled = true;

    try {
      this.onProceed();
    } finally {
      this.activeModal.close();
    }
  }

  public onChecked(outcome: LiveReaderCheckOutcome) {
    if (outcome === 'live') { return; }
    this.settled = true;
    this.activeModal.close();
  }

  public ngOnDestroy() {
    if (!this.settled) {
      this.onDismiss?.();
    }
  }
}
